import React from 'react';

const MailgunLogo = props => (
  <svg width={32} height={32} {...props}>
    <path
      d="M15.967 9.927c-3.33 0-6.04 2.71-6.04 6.04a6.048 6.048 0 0 0 6.04 6.041 6.048 6.048 0 0 0 6.041-6.04 6.048 6.048 0 0 0-6.04-6.041zm-9.404 6.04c0-5.191 4.213-9.404 9.404-9.404 5.192 0 9.404 4.213 9.404 9.404 0 .36-.032.686-.065 1.013-.065.914.588 1.6 1.502 1.6 1.535 0 1.698-1.992 1.698-2.645A12.556 12.556 0 0 0 15.935 3.363 12.556 12.556 0 0 0 3.363 15.935a12.556 12.556 0 0 0 12.572 12.571c3.69 0 6.987-1.6 9.306-4.114l2.58 2.155a15.86 15.86 0 0 1-11.886 5.322C7.118 31.87 0 24.72 0 15.935 0 7.118 7.151 0 15.935 0c8.816 0 15.934 7.151 15.934 15.935 0 3.526-1.698 6.4-5.06 6.4-1.503 0-2.385-.686-2.907-1.437a9.367 9.367 0 0 1-8 4.44c-5.126.033-9.339-4.179-9.339-9.37zm9.404-2.775c1.535 0 2.776 1.24 2.776 2.743a2.773 2.773 0 0 1-2.776 2.775 2.773 2.773 0 0 1-2.775-2.775c.032-1.502 1.24-2.743 2.775-2.743z"
      fill="#C02126"
    />
  </svg>
);

export default MailgunLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/MailgunLogo.es6.js